import axios from "axios";
import GlobalFile from "@/models/globalFile";
import store from "@/store";
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_GLOBAL_FILE_URL = process.env.VUE_APP_API_URL+"/global_files";
const API_FILE_URL = process.env.VUE_APP_API_URL+"/files";

export default class GlobalFileController {
    // Fetch all global files
    static async fetchGlobalFiles() {
        const response = await axios.get(`${API_GLOBAL_FILE_URL}/get_global_files`);
        console.log('Global files fetched successfully:', response.data);
        return response.data.map(gf => new GlobalFile(gf));
    }

    // Create a new global file
    static async uploadGlobalFile(formData) {
        var globalFileData = new GlobalFile({
            teacher_id: store.getters.userId,
            semester_id: store.getters.semesterId
        });
        GlobalFile.validate(globalFileData);
        console.log('Creating global file:', globalFileData);
        
        const respose = await axios.post(`${API_FILE_URL}/save_global_file/${globalFileData.semester_id}/${globalFileData.teacher_id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return respose;
    }

    // Download global file
    static async downloadGlobalFile(filePath) {
        const response = await axios.get(`${API_FILE_URL}/download_file`, {
            params: { relative_file_path: filePath },
            responseType: 'blob'
        });
        return response;
    }

    static async deleteGlobalFile(globalFileId) {
        const response = await axios.delete(`${API_FILE_URL}/delete_global_file/${globalFileId}`);
        return response;
    }
}

applyErrorHandlers(GlobalFileController);